import React from 'react'

import { PriceString, Tooltip } from '@fourthwall/components'
import type { Money } from '@fourthwall/services/dist/models/common'

import * as S from './VariantPrice.styled'

type VariantPriceProps = {
  price: Money
  oldPrice: Money
  tooltip: string
}

export const VariantPrice = ({ price, oldPrice, tooltip }: VariantPriceProps) => (
  <Tooltip
    reference={
      <S.Container>
        <S.OldPriceContainer>
          <PriceString value={oldPrice.value} />
        </S.OldPriceContainer>
        <div>
          <PriceString value={price.value} />
        </div>
      </S.Container>
    }
  >
    {tooltip}
  </Tooltip>
)
